VjsAdmin.UserForm1 = (function () {
    const init = function () {
        checkRole();

        $('#user_license_ids').multiselect();
        $('#role_id').on('change', () => {
            checkRole();
        });
    };

    const checkRole = function () {
        const roleId = $('#role_id').val();

        if (+roleId === 1) {
            // users
            $('#grade_id').closest('.form-group').show();
        } else {
            $('#grade_id').closest('.form-group').hide();
        }

        if (+roleId === 2) {
            $('#user-staff-settings').show();
        } else {
            $('#user-staff-settings').hide();
        }

        if (+roleId !== 4) {
            // staff and administrators
            $('#user_license_ids').closest('.form-group').show();
        } else {
            $('#user_license_ids').closest('.form-group').hide();
        }
    };

    return {
        init,
    };
}());
